import { ApolloClient, HttpLink, InMemoryCache, split } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { getMainDefinition } from "@apollo/client/utilities";
import { onError } from "@apollo/client/link/error";
import { createClient } from "graphql-ws";

// Create an auth link that adds the authorization header to each request
const authLink = setContext((_, { headers = {} }) => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
      "x-platform": "web-app",
    },
  };
});

const httpLink = new HttpLink({
  uri: import.meta.env.VITE_API_URL + "/graphql",
});

const wsLink = new GraphQLWsLink(
  createClient({
    url: import.meta.env.VITE_WS_URL + "/graphql",
    connectionParams: () => {
      const token = localStorage.getItem("token");
      return {
        authorization: token ? `Bearer ${token}` : "",
        "x-platform": "web-app",
      };
    },
  })
);

const errorLink = onError(({ graphQLErrors, networkError }) => {
  const isUnauthorized = graphQLErrors?.some(
    (error) => error.message === "Unauthorized"
  );

  if (isUnauthorized) {
    console.log("Unauthorized");
    window.location.href = "/signout";
    return;
  }

  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      console.error(
        `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
      );
    });
  }

  if (networkError) {
    console.error(`[Network error]: ${networkError}`);
  }

  // Navigate to error screen when any error occurs
  // router.replace("/error");
});

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === "OperationDefinition" &&
      definition.operation === "subscription"
    );
  },
  wsLink,
  errorLink.concat(authLink).concat(httpLink)
);

export const client = new ApolloClient({
  link: splitLink,
  cache: new InMemoryCache(),
});
